import { contentGet, contentPut } from '../email-activity/content-api'

// An organization's own settings on rapid-api-content: whether it allows AI
// tools usage data (owner decision 2026-10-23). Each answers
// { organizationID, aiToolsTelemetryAllowed }; a refusal throws
// { status, data: { code, message } } (serverMessage reads it).

// The signed-in organization's: read by its admins and owners
// (ORG_ORGANIZATION read), changed by its owners (update).
export const getOwnSetting = () => contentGet('organization-setting')
export const setOwnSetting = allowed => contentPut('organization-setting', { aiToolsTelemetryAllowed: !!allowed })

// Any organization's, for staff (SYS_ORGANIZATION read / update).
export const getOrgSetting = organizationID => contentGet(`organization/${organizationID}/setting`)
export const setOrgSetting = (organizationID, allowed) => contentPut(`organization/${organizationID}/setting`, { aiToolsTelemetryAllowed: !!allowed })
